import { render, staticRenderFns } from "./paymentInstallmentForm.vue?vue&type=template&id=2fcb64b0&scoped=true&"
import script from "./paymentInstallmentForm.vue?vue&type=script&lang=js&"
export * from "./paymentInstallmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb64b0",
  null
  
)

export default component.exports